import type { ExerciseTotalDurationInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCalculationsContext } from "../CalculationsContext"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileUnit } from "./TileUnit"
import { TileValue } from "./TileValue"
import { usePolyglot } from "src/contexts"
import { round } from "src/utils"

export function ExerciseTotalDuration(props: TileProps<ExerciseTotalDurationInsight>) {
  const {
    insightKey,
    range,
  } = props

  const polyglot = usePolyglot()

  const { exerciseCalculations } = useCalculationsContext()
  const { totalInSeconds } = exerciseCalculations[range] || {}

  const value = totalInSeconds === undefined ?
    NaN :
    round(totalInSeconds / 60)

  const unit = polyglot.t(
    "time.min_unit",
    isNaN(value) ? 0 : value,
  )

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        range={range}
        id={`${insightKey}-time-range`}
      />
      <TileValue id={`${insightKey}-value`}>
        {isNaN(value) ? "--" : `${value}`}
      </TileValue>
      <TileUnit id={`${insightKey}-unit`}>
        {unit}
      </TileUnit>
    </>
  )
}
